import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

const choices = ["Āe", "Kāo"];

export const eligibilityConfig: PageConfig[] = [
  {
    name: "eligibility",
    title: "Eligibility Check",
    questions: [
      {
        type: "radiogroup",
        name: "commercial",
        title:
          "Is this initiative a commercial venture or for profit activity?",
        choices,
        isRequired: true,
        validators: [
          {
            type: "expression",
            text: "Only not for profit activites are eligible for this fund",
            expression: "{commercial} = 'Kāo'",
          },
        ],
      },
      {
        type: "radiogroup",
        name: "retrospective",
        title: "Is this a retrospective application?",
        choices,
        isRequired: true,
        validators: [
          {
            type: "expression",
            text:
              "Applications need to be made prior to be eligible for this fund",
            expression: "{retrospective} = 'Kāo'",
          },
        ],
      },
      {
        type: "radiogroup",
        name: "otherStreams",
        title:
          "Is this initiative already funded by other Rangitāne funding streams?",
        choices,
        isRequired: true,
        validators: [
          {
            type: "expression",
            text: `
            Only initiatives not covered by other funding are eligible for this
            fund
          `,
            expression: "{otherStreams} = 'Kāo'",
          },
        ],
      },
      {
        type: "radiogroup",
        name: "charged",
        title: "Will participants be charged to attend?",
        choices,
        isRequired: true,
      },
      {
        type: "text",
        name: "chargedDetails",
        title: "Please provide details of charges and why",
        visibleIf: "{charged} = 'Āe'",
        isRequired: true,
      },
    ],
  },
];
